import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import BilateralLoanData from "../../../../components/bilateralLoanData";
import BilateralGuaranteeInAccount from "../../../../components/bilateralGuaranteeInAccount";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';
import PropTypes from "prop-types";
import {InputText} from "primereact/inputtext";

const BilateralCaptureGuaranteeView = ({...props}) => {
    return (
        <LoadingOverlay
            active={props.isLoading}
            spinner
            text='Cargando...'>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Bilaterales \ Tablero de Control \ Concertación"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Guardar"
                            style={{'float': 'right'}}
                            onClick={props.saveGuarantees}
                        />&nbsp;
                        <Button
                            label="Rechazar"
                            className="p-button-secondary"
                            style={{'float': 'right'}}
                            onClick={props.openConfirmationReject}
                        />&nbsp;
                        <Button
                            label="Regresar"
                            style={{'float': 'right'}}
                            className="p-button-secondary"
                            onClick={props.handleReturnButton}
                        />&nbsp;

                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <BilateralLoanData
                        ref={props.bilateralLoanData}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading} />
                    <Grid item xs={12}>
                        <br/>
                        <Divider/>
                    </Grid>
                    <Grid item xs={3}>
                        <SubtitleLabel header="Cuenta " isBold={true}/>
                        <InputText name="borrowerAccount"
                                   placeholder={"Ex: AAAA999999XYZ"}
                                   maxLength={50}
                                   onChange={props.onChangeAccount}
                                   value={props.borrowerAccount}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <BilateralGuaranteeInAccount
                        ref={props.guaranteeInAccount}
                        loading={props.loading}
                        selectedLoan={props.selectedLoan}
                        subtitle={'Garantías'}
                    />
                    {props.confirmationMessage}
                </Grid>
            </Paper>
        </LoadingOverlay>
    )
};

export default BilateralCaptureGuaranteeView;

BilateralCaptureGuaranteeView.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    saveGuarantees: PropTypes.func.isRequired,
    openConfirmationReject: PropTypes.func.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    selectedLoan: PropTypes.object.isRequired,
    loading: PropTypes.func.isRequired,
    guaranteeInAccount: PropTypes.object.isRequired,
    bilateralLoanData: PropTypes.object.isRequired,
    confirmationMessage: PropTypes.object.isRequired,
    onChangeAccount: PropTypes.func.isRequired,
    borrowerAccount: PropTypes.string.isRequired,
};